module.exports = __webpack_public_path__ + "img/crystal.a624233.webp";